module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Test Email Server\">\r\n    <p>\r\n        Enter the email address and subject for sending a test email to.\r\n    </p>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\">\r\n            <label style=\"margin-top: 5px;\">Email:</label>\r\n        </div>\r\n        <div class=\"col-md-10\">\r\n            <input type=\"text\" name=\"email\">\r\n        </div>\r\n    </div>\r\n    <br />\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\">\r\n            <label  style=\"margin-top: 5px;\">Subject:</label>\r\n        </div>\r\n        <div class=\"col-md-10\">\r\n            <input type=\"text\" name=\"subject\" value=\"Test\">\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}